import { createLoaderImp } from '../../../components/ozmoit/common';
import { getRiskObservationsStudentsList } from '../actions';

const {
  useLoader: useRiskObservationsStudentListLoader,
  LoaderProvider: StudentRiskObservationsStudentListLoader,
} = createLoaderImp({
  action: getRiskObservationsStudentsList,
});



export {
  useRiskObservationsStudentListLoader,
  StudentRiskObservationsStudentListLoader,
};
